import { get as getCookie, remove as removeCookie } from 'es-cookie';
import { CookieAttributes } from 'es-cookie/src/CookieAttributes';

import { AuthTokenType } from 'domain/auth/types';

import { setCookieByKey } from './cookies';

export const AUTH_COOKIE_NAME = 'JWT';
export const AUTH_COOKIE_ATTRIBUTES: CookieAttributes = { expires: 30 };

export const getTokenCookie = (): AuthTokenType | undefined => getCookie(AUTH_COOKIE_NAME);

export const setTokenCookie = (token: AuthTokenType): void => {
  if (token) {
    setCookieByKey(AUTH_COOKIE_NAME, token, AUTH_COOKIE_ATTRIBUTES);
  }
};

export const removeTokenCookie = (): void => removeCookie(AUTH_COOKIE_NAME);
